import * as MUI from "@mui/material";

/** Label-above-value field for a CSS-grid inside a SectionCard. */
export default function DetailField({ label, value, emphasize }) {
  return (
    <MUI.Box>
      <MUI.Typography
        variant="caption"
        color="text.secondary"
        sx={{ textTransform: "uppercase", letterSpacing: "0.04em" }}
      >
        {label}
      </MUI.Typography>
      <MUI.Typography
        variant={emphasize ? "subtitle1" : "body2"}
        sx={{ fontWeight: emphasize ? 700 : 500, mt: 0.25 }}
        color={emphasize ? "primary.main" : "text.primary"}
      >
        {value}
      </MUI.Typography>
    </MUI.Box>
  );
}
